import React, { useMemo } from 'react';
import { Row, Col } from 'reactstrap';
import PropTypes from 'prop-types';
import Input from 'components/atoms/input';
import useUser from 'utils/useUser';
import { isPractice } from 'utils/userTypeHelper';
import { fullNamePresenter } from 'utils';

const Representatives = ({ clinic, errors }) => {
  const { userType } = useUser();
  const canEditRepresentatives = !isPractice(userType);

  const {
    clientSuccessOnboarding,
    clientSuccessScaling,
    salesRepresentative,
    clientSuccessOnboardingOptions,
    clientSuccessScalingOptions,
    salesRepresentatives,
  } = clinic;

  const options = useMemo(() => {
    if (
      canEditRepresentatives &&
      clientSuccessOnboardingOptions &&
      clientSuccessScalingOptions &&
      salesRepresentatives
    ) {
      return {
        clientSuccessOnboarding: [
          { id: null, label: 'None' },
          ...clientSuccessOnboardingOptions,
        ],
        clientSuccessScaling: [
          { id: null, label: 'None' },
          ...clientSuccessScalingOptions,
        ],
        salesRepresentative: [
          { id: null, label: 'None' },
          ...salesRepresentatives,
        ],
      };
    }
    return {
      clientSuccessOnboarding: [
        {
          id: clinic.clientSuccessOnboardingGuid,
          label: fullNamePresenter(clientSuccessOnboarding),
        },
      ],
      clientSuccessScaling: [
        {
          id: clinic.clientSuccessScalingGuid,
          label: fullNamePresenter(clientSuccessScaling),
        },
      ],
      salesRepresentative: [
        {
          id: clinic.salesRepresentativeGuid,
          label: fullNamePresenter(salesRepresentative),
        },
      ],
    };
  }, [clinic]);

  return (
    <div className="admin-patient-form-block">
      <span>Representatives</span>
      <Row>
        <Col lg="12" md="12" sm="12" xs="12">
          <Input
            label="Clinic Success Onboarding"
            id="clientSuccessOnboardingGuid"
            type="select"
            isMulti={false}
            disabled={!canEditRepresentatives}
            options={options.clientSuccessOnboarding}
          />
          {errors.clientSuccessOnboardingGuid ? (
            <div className="input-error">
              {errors.clientSuccessOnboardingGuid}
            </div>
          ) : null}
        </Col>
        <Col lg="12" md="12" sm="12" xs="12">
          <Input
            label="Clinic Success Scaling"
            id="clientSuccessScalingGuid"
            type="select"
            isMulti={false}
            disabled={!canEditRepresentatives}
            options={options.clientSuccessScaling}
          />
          {errors.clientSuccessScalingGuid ? (
            <div className="input-error">{errors.clientSuccessScalingGuid}</div>
          ) : null}
        </Col>
        <Col lg="12" md="12" sm="12" xs="12">
          <Input
            label="Sales"
            id="salesRepresentativeGuid"
            type="select"
            isMulti={false}
            disabled={!canEditRepresentatives}
            options={options.salesRepresentative}
          />
          {errors.salesRepresentativeGuid ? (
            <div className="input-error">{errors.salesRepresentativeGuid}</div>
          ) : null}
        </Col>
      </Row>
    </div>
  );
};

Representatives.propTypes = {
  errors: PropTypes.shape({
    salesRepresentativeGuid: PropTypes.array,
    clientSuccessOnboardingGuid: PropTypes.array,
    clientSuccessScalingGuid: PropTypes.array,
  }).isRequired,
  clinic: PropTypes.shape().isRequired,
};

export default Representatives;
